export const roomPath = (slug: string): string => `/r/${encodeURIComponent(slug)}`;
